import React, { useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { ListItemButton, Stack, Typography } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import ReportDataGridModal from './ReportDataGridModal';
import AppointmentReportDataGrid from '../lists/AppointmentReportDataGrid';
import { getInventoryCurrentStock, getInventoryLowStock, getInventoryExpiring } from '../../../api/reportService';
import InventoryCurrentStockReportDataGrid from '../lists/InventoryCurrentStockReportDataGrid';
import InventoryLowStockReportDataGrid from '../lists/InventoryLowStockReportDataGrid';
import InventoryExpiringReportDataGrid from '../lists/InventoryExpiringReportDataGrid';
import InventoryTransactionsReport from './InventoryTransactionsReport';

export default function InventoryReport({mode = 'list'}) {
  const { t } = useTranslation('common'); 
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const { showSnackbar } = useSnackbar();

  const [fetchingData, setFetchingData] = useState(false);

  const [viewOpen, setViewOpen] = React.useState(false);
  const [reportData, setReportData] = useState(null);
  const [reportType, setReportType] = useState("");
  const [reportModalTitle, setReportModalTitle] = useState("");

  const fetchData = async (type) => {
    setReportType(type);
    let endpoint = null;
    if (type === 'currentStock') {
      setReportModalTitle('Inventory Current Stock');
      endpoint = getInventoryCurrentStock;
    } else if (type === 'lowStock') {
      setReportModalTitle('Inventory Low Stock Items');
      endpoint = getInventoryLowStock;
    } else if (type === 'expiring') {
      setReportModalTitle('Inventory Expiring Items');
      endpoint = getInventoryExpiring;
    }
    try {
      setFetchingData(true)
      const response = await endpoint(true);
      // console.log(response);
      setReportData(response || null);
      setViewOpen(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setFetchingData(false);
    }
  }; 

  return (
    <React.Fragment>
      {mode === 'list' ? 
        <ListItem>
          <ListItemButton onClick={handleClickOpen}>
          <ListItemIcon>
            <InventoryIcon fontSize='large' color='secondary'/>
          </ListItemIcon>
          <ListItemText 
            primary="Inventory"
            secondary="generate inventory report"
          />
          </ListItemButton>
        </ListItem>
      : null }
      {mode === 'button' ? 
        <Button onClick={handleClickOpen}>Inventory Report</Button>
      : null }

      <Dialog onClose={handleClose} open={open} disableRestoreFocus>

        <DialogTitle>
        <Stack spacing={1}>
          <Typography variant="h6">Inventory Report</Typography>
        </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <>
            <Stack spacing={2}>
            <Button
              variant='outlined'
              fullWidth
              onClick={() => fetchData('currentStock')}
            >
              Current Stock Levels
            </Button>

            <Button
              variant='outlined'
              fullWidth
              onClick={() => fetchData('lowStock')}
            >
              Low Stock Items
            </Button>

            <Button
              variant='outlined'
              fullWidth
              onClick={() => fetchData('expiring')}
            >
              Expiring Items
            </Button>

            <InventoryTransactionsReport mode='button' />
            </Stack>
          </>
        </DialogContent>

        <DialogActions>
          <div style={{flex: '1 0 0'}} />
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
        {reportType === 'currentStock' ?
          <ReportDataGridModal 
            title={reportModalTitle}
            reportData={reportData}
            reportDataGrid={<InventoryCurrentStockReportDataGrid data={reportData?.data} />}
            open={viewOpen}
            onClose={() => {
              setViewOpen(false);
            }}
          />
        : null}
        {reportType === 'lowStock' ?
          <ReportDataGridModal 
            title={reportModalTitle}
            reportData={reportData}
            reportDataGrid={<InventoryLowStockReportDataGrid data={reportData?.data} />}
            open={viewOpen}
            onClose={() => {
              setViewOpen(false);
            }}
          />
        : null}
        {reportType === 'expiring' ?
          <ReportDataGridModal 
            title={reportModalTitle}
            reportData={reportData}
            reportDataGrid={<InventoryExpiringReportDataGrid data={reportData?.data} />}
            open={viewOpen}
            onClose={() => {
              setViewOpen(false);
            }}
          />
        : null}
      </Dialog>
    </React.Fragment>
  );
}